<template>
  <CommonUINavbar />
  <div class="error" data-testid="error-page">
    <h1 class="error__title" data-testid="error-page-title">{{ errorInfo?.title || 'Error' }}</h1>
    <p class="error__message" data-testid="error-page-message">
      {{ errorInfo?.message || props.error.message || 'Ha ocurrido un error.' }}
    </p>
    <Button v-slot="slotProps" as-child>
      <RouterLink to="/" :class="slotProps.class">
        <Icon size="20" name="mdi:arrow-left" class="error__link-icon" />
        <span class="error__link-text">Volver al inicio</span>
      </RouterLink>
    </Button>
  </div>
</template>

<script setup lang="ts">
  import type { NuxtError } from '#app';

  // props
  const props = defineProps<{ error: NuxtError }>();

  // computed
  const errorInfo = {
    404: {
      title: '404',
      message: 'No hemos encontrado lo que buscas.',
    },
    401: {
      title: '401',
      message: 'Tu sesión ha expirado o no estás autenticado. Inicia sesión para continuar.',
    },
    403: {
      title: '403',
      message: 'No tienes permisos para acceder a esta página.',
    },
    500: {
      title: '500',
      message: 'Ha ocurrido un error en el servidor.',
    },
  }[props.error.statusCode ?? 500];
</script>

<style scoped>
  @reference '~/assets/css/main.css';

  .error {
    @apply flex h-[calc(100vh-10rem)] flex-col items-center justify-center gap-5 bg-white;
  }

  .error__title {
    @apply text-primary-1 text-7xl font-bold;
  }

  .error__message {
    @apply font-light text-black;
  }

  .error__link {
    @apply bg-primary-1 flex cursor-pointer items-center gap-2 rounded-md p-2 text-white hover:opacity-90;
  }

  .error__link-icon {
    @apply text-white;
  }

  .error__link-text {
    @apply text-white;
  }
</style>
